export default (sections, instructionId) => {
	return [
		...sections.map((section) => {
			return {
				...section,
				instructions: section.instructions ? [...section.instructions.filter((item) => item.id !== instructionId)] : []
			};
		})
	];
};
